import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import toggleLeftIcon from "../../static/menu_icon/toggleLeft.svg";
import toggleRightIcon from "../../static/menu_icon/toggleRight.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import menus from "../../shared/data/menu";
import {
  filterMenusByRole,
  MenuItemConfig,
  SubmenuItemConfig,
} from "../../utils/routeAuth";
import colors from "../../shared/constants/color";
import { RootState } from "../../redux/reducers";
import { toggleSidebar } from "../../redux/slices/ui";
import Tooltip from "../Tooltip";
import {
  SidebarContainer,
  SidebarHeader,
  UserInfo,
  UserDetails,
  UserName,
  UserRole,
  ToggleContainer,
  ToggleButton,
  SidebarMenu,
  MenuList,
  MenuItem,
  MenuLink,
  MenuIcon,
  MenuItemWithSubmenu,
  MenuItemButton,
  MenuLabel,
  Submenu,
  SubmenuItem,
  SubmenuLink,
  SubmenuLabel,
  MenuContentWrapper,
  SidebarFooter,
} from "./style";
import DarkModeToggle from "../header/DarkModeToggle";

// Menu tip tanımlamaları
// Menu tipleri routeAuth'tan gelir; yetki alanlari (role/roles) da orada tanimli.
type SubmenuItem = SubmenuItemConfig;
type MenuItem = MenuItemConfig;

// const userName = localStorage.getItem('userName');

// const formatUserName = (userName: string | null): string => {
//   if (!userName) return '';
//   return userName
//       .replace(/['"]/g, '')
//       .split('.')
//       .map((word: string, index: number) => {
//           if (index === 0) {
//               return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
//           }
//           return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
//       })
//       .join(' ');
// };

const Sidebar = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state: RootState) => state.ui.sidebar);
  // Kullanicinin yetkisi olmayan menuler (ve alt ogesi kalmayan ustler) gizlenir.
  const visibleMenus = filterMenusByRole(menus, localStorage.getItem("roles"));

  const [openSubmenus, setOpenSubmenus] = useState<Record<number, boolean>>({});
  const sidebarRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  const toggleSidebarHandler = () => {
    dispatch(toggleSidebar({}));
  };

  const toggleSubmenu = (menuId: number) => {
    // Eğer sidebar kapalıysa, önce sidebar'ı aç
    if (!isOpen) {
      dispatch(toggleSidebar({}));
      // Sidebar açıldığında submenu'yu da aç
      setOpenSubmenus({ [menuId]: true });
      return;
    }

    const menu = visibleMenus.find((m: MenuItem) => m.id === menuId);
    const currentExpanded = menu ? isExpanded(menu) : !!openSubmenus[menuId];
    setOpenSubmenus({ [menuId]: !currentExpanded });
  };

  useEffect(() => {
    if (!isOpen) {
      setOpenSubmenus({});
      return;
    }
    const activeWithSub = visibleMenus.find(
      (m: MenuItem) =>
        Array.isArray(m.submenu) &&
        m.submenu.some((s: SubmenuItem) => s.url === location.pathname),
    );
    if (activeWithSub) {
      setOpenSubmenus({ [activeWithSub.id]: true });
    } else {
      setOpenSubmenus({});
    }
  }, [location.pathname, isOpen]);

  const getIcon = (icon: string) => {
    const isTrackingIcon = icon.includes("candidateTracking");
    const size = isTrackingIcon ? "24px" : "20px";
    return (
      <img
        src={icon}
        alt="menu icon"
        style={{ width: size, height: size, objectFit: "contain" }}
      />
    );
  };
  // const formattedUserName = formatUserName(userName);

  const isRouteInMenu = (menu: MenuItem) =>
    Array.isArray(menu.submenu) &&
    menu.submenu.some((s: SubmenuItem) => s.url === location.pathname);

  const isExpanded = (menu: MenuItem) => {
    const state = openSubmenus[menu.id];
    if (state !== undefined) return state;
    return isRouteInMenu(menu);
  };

  const renderMenuLabel = (label: string) => {
    const gradientStyle: React.CSSProperties = {
      background: colors.aiLinearGradient,
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      WebkitTextFillColor: "transparent",
      color: "transparent",
    };

    // Gradient uygulanacak string'ler
    const gradientStrings = ["AI Arama", "Aday Aktarma"];

    for (const gradientString of gradientStrings) {
      // Eğer label tamamen bu string'e eşitse, tamamını gradient yap
      if (label === gradientString) {
        return <span style={gradientStyle}>{label}</span>;
      }

      // Eğer label içinde bu string geçiyorsa, sadece o kısmı gradient yap
      const stringIndex = label.indexOf(gradientString);
      if (stringIndex !== -1) {
        const before = label.slice(0, stringIndex);
        const after = label.slice(stringIndex + gradientString.length);
        return (
          <>
            {before}
            <span style={gradientStyle}>{gradientString}</span>
            {after}
          </>
        );
      }
    }

    return label;
  };

  const isMenuActive = (menu: MenuItem) => {
    if (menu.url === location.pathname) return true;
    if (menu.submenu) {
      return menu.submenu.some(
        (sub: SubmenuItem) => sub.url === location.pathname,
      );
    }
    return false;
  };

  // const { myUserDetailList } = useSelector(
  //   (state: RootState) => state.myUserDetail
  // );

  // const getUserRole = () => {
  //   if (!myUserDetailList) {
  //     return '';
  //   }

  //   if (!Array.isArray(myUserDetailList)) {
  //     if (typeof myUserDetailList === 'object' && myUserDetailList !== null) {
  //       const roles: string[] = [];

  //       Object.values(myUserDetailList).forEach((value: any) => {
  //         if (value && typeof value === 'object' && value.DepartmentList) {
  //           if (Array.isArray(value.DepartmentList)) {
  //             value.DepartmentList.forEach((department: any) => {
  //               if (department.Task && !roles.includes(department.Task)) {
  //                 roles.push(department.Task);
  //               }
  //             });
  //           }
  //         }
  //       });
  //       return roles.join(', ');
  //     }
  //     return '';
  //   }

  //   if (myUserDetailList.length === 0) {
  //     return '';
  //   }

  //   const roles: string[] = [];
  //   myUserDetailList.forEach((userItem: any) => {
  //     if (userItem.DepartmentList && Array.isArray(userItem.DepartmentList)) {
  //       userItem.DepartmentList.forEach((department: any) => {
  //         if (department.Task && !roles.includes(department.Task)) {
  //           roles.push(department.Task);
  //         }
  //       });
  //     }
  //   });
  //   return roles.join(', ');
  // };

  return (
    <SidebarContainer isOpen={isOpen} ref={sidebarRef} className="wiser-sidebar">
      {/* <SidebarHeader>
        <UserInfo>
          <AccountCircleIcon style={{ fontSize: 35, color: '#5d6b8a' }} />
          <UserDetails isOpen={isOpen}>
            <UserName>{formattedUserName}</UserName>
            <UserRole>{getUserRole()}</UserRole>
          </UserDetails>
        </UserInfo>
      </SidebarHeader> */}

      <SidebarMenu>
        <MenuList>
          {visibleMenus
            .filter((menu: MenuItem) => !menu.hidden && !menu.disabled)
            .map((menu: MenuItem) => {
            const validSubmenus =
              menu.submenu?.filter((item) => item.label) || [];
            const hasValidSubmenus = validSubmenus.length > 0;
            const isSubmenuRouteActive = isRouteInMenu(menu);
            const shouldUseActiveIcon =
              menu.url === location.pathname ||
              (menu.activeOnSubmenuRoute && isSubmenuRouteActive);
            const iconToRender =
              shouldUseActiveIcon && menu.activeIcon
                ? menu.activeIcon
                : menu.icon;

            return (
              <MenuItem
                key={menu.id}
                className={`${isMenuActive(menu) ? "active" : ""} ${
                  menu.disableActiveTypography ? "no-active-typography" : ""
                }`.trim()}
              >
                {hasValidSubmenus ? (
                  <MenuItemWithSubmenu>
                    {!isOpen ? (
                      <Tooltip
                        text={menu.tooltip || menu.label}
                        position="right"
                      >
                        <MenuItemButton
                          onClick={() => {
                            toggleSubmenu(menu.id);
                          }}
                        >
                          <MenuIcon>{getIcon(iconToRender)}</MenuIcon>
                          <MenuContentWrapper>
                            <MenuLabel>{renderMenuLabel(menu.label)}</MenuLabel>
                            {isOpen &&
                              (isExpanded(menu) ? (
                                <KeyboardArrowDownIcon />
                              ) : (
                                <KeyboardArrowRightIcon />
                              ))}
                          </MenuContentWrapper>
                        </MenuItemButton>
                      </Tooltip>
                    ) : (
                      <MenuItemButton
                        onClick={() => {
                          toggleSubmenu(menu.id);
                        }}
                      >
                        <MenuIcon>{getIcon(iconToRender)}</MenuIcon>
                        <MenuContentWrapper>
                          <MenuLabel>{renderMenuLabel(menu.label)}</MenuLabel>
                          {isOpen &&
                            (isExpanded(menu) ? (
                              <KeyboardArrowDownIcon />
                            ) : (
                              <KeyboardArrowRightIcon />
                            ))}
                        </MenuContentWrapper>
                      </MenuItemButton>
                    )}
                    <Submenu expanded={isOpen && isExpanded(menu)}>
                      {validSubmenus.map((submenu: SubmenuItem) => (
                        <SubmenuItem key={submenu.id}>
                          <SubmenuLink to={submenu.url}>
                            <SubmenuLabel>{submenu.label}</SubmenuLabel>
                          </SubmenuLink>
                        </SubmenuItem>
                      ))}
                    </Submenu>
                  </MenuItemWithSubmenu>
                ) : !isOpen ? (
                  <Tooltip text={menu.tooltip || menu.label} position="right">
                    <MenuLink to={menu.url}>
                      <MenuIcon>{getIcon(iconToRender)}</MenuIcon>
                      <MenuContentWrapper>
                        <MenuLabel>{renderMenuLabel(menu.label)}</MenuLabel>
                      </MenuContentWrapper>
                    </MenuLink>
                  </Tooltip>
                ) : (
                  <MenuLink to={menu.url}>
                    <MenuIcon>{getIcon(iconToRender)}</MenuIcon>
                    <MenuContentWrapper>
                      <MenuLabel>{renderMenuLabel(menu.label)}</MenuLabel>
                    </MenuContentWrapper>
                  </MenuLink>
                )}
              </MenuItem>
            );
          })}
        </MenuList>
      </SidebarMenu>

      <SidebarFooter>
        <DarkModeToggle variant="sidebar" compact={!isOpen} />
      </SidebarFooter>

      <ToggleContainer>
        <ToggleButton onClick={toggleSidebarHandler}>
          <img
            src={isOpen ? toggleLeftIcon : toggleRightIcon}
            alt="toggle sidebar"
          />
        </ToggleButton>
      </ToggleContainer>
    </SidebarContainer>
  );
};

export default Sidebar;
